import {
  SeasonFragment,
  SeasonLeagueFragment,
  TeamListItemFragment,
} from '@amf/shared/types/graphql';

type TeamDefaults = {
  season: SeasonFragment | null;
  league: SeasonLeagueFragment | null;
};

export function findTeamDefaults(
  team?: TeamListItemFragment,
  seasons?: SeasonFragment[],
): TeamDefaults {
  if (!team || !seasons) return { season: null, league: null };
  for (const season of seasons) {
    const league = season.leagues.find(({ id }) => team.playedLeagueIds.includes(id));
    if (league) return { season, league };
  }

  return {
    season: null,
    league: null,
  };
}

export function findTeamDefaultLeague(
  team?: TeamListItemFragment,
  season?: SeasonFragment,
): SeasonLeagueFragment | null {
  if (!team || !season) return null;
  const league = season.leagues.find(({ id }) => team.playedLeagueIds.includes(id));
  if (league) return league;
  return null;
}
